<template>
  <main class="main">
    <article>
      <h1>Erreur 404</h1>
      <div>
        <p>Cette page n'existe pas ou n'existe plus.</p>
        <p>Nous vous prions de nous excuser pour la gêne occasionnée.</p>
      </div>
    </article>
  </main>
</template>

<script>
export default {
  name: 'ErrorPage'
}
</script>
